import { View } from "react-native";
import { Props } from "./types";
import { IconButton, Text } from "react-native-paper";
import { useNavigation } from "@react-navigation/native";

export default function ScreenContainer({ navigationTitle, children, goBack, noBorder, noBackButton, overrideBack }: Props) {
  const navigation = useNavigation();

  const className = noBorder ? "max-w-3xl w-full" : "max-w-3xl w-full sm:m-4 sm:border border-sky rounded-lg sm:p-8 sm:mb-10";

  const onBackIconPress = () => {
    if (overrideBack) {
      return overrideBack();
    }

    if (navigation.canGoBack()) {
      return navigation.goBack();
    }

    if (goBack) {
      return goBack();
    }

    if (window && window.history) {
      return window.history.back();
    }
  };

  return (
    <View className="bg-white flex min-h-full items-center justify-start sm:pt-8 sm:px-8">
      <View className={className}>
        {!!navigationTitle && (
          <View className="flex-row items-center mt-4">
            {!noBackButton && <IconButton icon="chevron-left" onPress={onBackIconPress} />}
            <Text className={`text-title-5 font-700 text-ink-darker sm:text-title-3 ${noBackButton ? "ml-6" : ""}`}>
              {navigationTitle}
            </Text>
          </View>
        )}
        {children}
      </View>
    </View>
  );
}
